import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { getUserRole } from 'dashboard/helper/permissionsHelper';
import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import bonbozPageLabels from './pageLabels/pageLabels.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import pageAppearance from './pageAppearance/pageAppearance.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import captain from './captain/captain.routes';
import data from './data/data.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      // BonBoZ: Cai dat chi danh cho quan tri; nguoi truc bi tra ve hoi thoai.
      //
      // Dat o `beforeEnter` chu khong phai `redirect`: `redirect` chay TRUOC
      // guard, dich cuoi thanh mot route khac nen quyen dat tren route nay
      // khong bao gio duoc xet — agent van vao duoc Cai dat.
      //
      // Va lay accountId tu `to.params` chu khong dung `getCurrentRole`: getter
      // do doc route DA commit, ma luc nay route moi chua commit nen no rong,
      // admin bi day nham ve hoi thoai.
      beforeEnter: to => {
        const laQuanTri =
          getUserRole(store.getters.getCurrentUser, to.params.accountId) ===
          'administrator';

        return laQuanTri
          ? { name: 'general_settings_index', params: to.params }
          : { name: 'home', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...bonbozPageLabels.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...data.routes,
    ...labels.routes,
    ...macros.routes,
    ...pageAppearance.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
  ],
};
